import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search.vue')
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/Service.vue')
  },
  {
    path: '/service/:id',
    name: 'ServiceDetail',
    component: () => import('../views/ServiceDetail.vue')
  },
  {
    path: '/cases',
    name: 'Cases',
    component: () => import('../views/Cases.vue')
  },
  {
    path: '/cases/:id',
    name: 'CaseDetail',
    component: () => import('../views/CaseDetail.vue')
  },
  {
    path: '/engineer/demands',
    name: 'EngineerDemands',
    component: () => import('../views/EngineerDemands.vue')
  },
  {
    path: '/engineer',
    name: 'Engineer',
    component: () => import('../views/Engineer.vue')
  },
  {
    path: '/engineer/:id',
    name: 'EngineerDetail',
    component: () => import('../views/EngineerDetail.vue')
  },
  {
    path: '/course',
    name: 'Course',
    component: () => import('../views/Course.vue')
  },
  {
    path: '/course/:id',
    name: 'CourseDetail',
    component: () => import('../views/CourseDetail.vue')
  },
  {
    path: '/resource',
    name: 'Resource',
    component: () => import('../views/Resource.vue')
  },
  {
    path: '/resource/:id',
    name: 'ResourceDetail',
    component: () => import('../views/ResourceDetail.vue')
  },
  {
    path: '/publish',
    name: 'Publish',
    component: () => import('../views/Publish.vue')
  },
  {
    path: '/engineer-home',
    name: 'EngineerHome',
    component: () => import('../views/EngineerHome.vue')
  },
  {
    path: '/identity',
    name: 'IdentitySelect',
    component: () => import('../views/IdentitySelect.vue')
  },
  {
    path: '/profile-setup',
    name: 'ProfileSetup',
    component: () => import('../views/ProfileSetup.vue')
  },
  {
    path: '/apply-engineer',
    name: 'ApplyEngineer',
    component: () => import('../views/ApplyEngineer.vue')
  },
  {
    path: '/apply-engineer/case/add',
    name: 'AddSuccessCase',
    component: () => import('../views/AddSuccessCase.vue')
  },
  {
    path: '/user/published-requirements/:id',
    name: 'UserPublishedRequirementDetail',
    component: () => import('../views/user/UserPublishedRequirementDetail.vue')
  },
  {
    path: '/user',
    component: () => import('../views/UserCenter.vue'),
    redirect: '/user/projects',
    children: [
      {
        path: 'projects',
        name: 'UserProjects',
        component: () => import('../views/user/UserProjects.vue')
      },
      {
        path: 'closed',
        name: 'UserClosedProjects',
        component: () => import('../views/user/UserClosedProjects.vue')
      },
      {
        path: 'published-requirements',
        name: 'UserPublishedRequirements',
        component: () => import('../views/user/UserPublishedRequirements.vue')
      },
      {
        path: 'engineer',
        name: 'UserEngineer',
        component: () => import('../views/user/UserEngineer.vue')
      },
      {
        path: 'support',
        name: 'UserSupport',
        component: () => import('../views/user/UserSupport.vue')
      },
      {
        path: 'settings',
        name: 'UserSettings',
        component: () => import('../views/user/UserSettings.vue')
      },
      {
        path: 'settings/:type',
        name: 'UserAgreementDetail',
        component: () => import('../views/user/UserAgreementDetail.vue')
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: () => import('../views/user/UserProfile.vue')
      },
      {
        path: 'avatar',
        name: 'UserAvatarSelect',
        component: () => import('../views/user/UserAvatarSelect.vue')
      },
      {
        path: 'unlock-records',
        name: 'UserUnlockRecords',
        component: () => import('../views/engineer/EngineerApply.vue')
      },
      {
        path: 'vip',
        name: 'UserVip',
        component: () => import('../views/engineer/EngineerVip.vue')
      }
    ]
  },
  {
    path: '/engineer-center',
    redirect: '/user/projects'
  },
  {
    path: '/engineer-center/:subPath(.*)',
    redirect: (to) => {
      const subPath = to.params.subPath || ''
      if (subPath === 'engineer') return '/user/unlock-records'
      return `/user/${subPath}`
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 实际滚动容器是 .app-body（非 window），路由切换后回到顶部
router.afterEach(() => {
  Vue.nextTick(() => {
    const el = document.querySelector('.app-body')
    if (el) el.scrollTop = 0
  })
})

export default router
